import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./assets/scss/main.scss";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./components/AuthContext/AuthContext";
import { datadogRum } from '@datadog/browser-rum';
 
datadogRum.init({
    applicationId: 'ef22e717-ef2c-4a56-b019-b9b32f730000',
    clientToken: 'pub21b8f104dc67b1d4c0e3b8af0611f72f',
    site: 'datadoghq.eu',
    service: 'dashboard-production',
    env: 'production',
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>
  </BrowserRouter>
);

// For performance monitoring
reportWebVitals();